import { createRoot } from "react-dom/client";
import "@intility/bifrost-react/bifrost-app.css";
import "./global.css";
import App from "./App.tsx";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

createRoot(rootElement).render(<App />);
